import React from "react";
import { deleteData } from "../../utility/adminApi";
import { useQueryClient, useMutation } from "@tanstack/react-query";

function NotificationClear() {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: () => deleteData(`notifications/allread/delete`, ""),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["notifications"] });
    },
  });
  const handleDelete = () => {
    mutation.mutate();
  };
  return (
    <>
      <h4
        onClick={handleDelete}
        className="text-blue-500 cursor-pointer hover:underline"
      >
        Clear read notifications
      </h4>
    </>
  );
}

export default NotificationClear;
